module.exports = __webpack_public_path__ + "img/banner-e.c34746e8.png";